import { LinkTo } from '@ember/routing';
import isActive from 'ember-router-helpers/helpers/is-active';
import { PhCaretRight } from 'ember-phosphor-icons';
import type { WithBoundArgs } from '@glint/template';
import type { TOC } from '@ember/component/template-only';

interface CrumbSignature {
  Args: {
    label: string;
    // LinkTo accepts any model type (Ember Data models, strings, plain objects, etc.)
    model?: unknown;
    route?: string;
  };
  Element: HTMLLIElement;
}

const Crumb: TOC<CrumbSignature> = <template>
  {{#let (isActive @route) as |isActive|}}
    <li class="inline-block pl-1 pr-1 first:pl-0" ...attributes>
      {{#if @model}}
        <LinkTo
          @route={{@route}}
          @model={{@model}}
          class={{if isActive "font-semibold" "underline"}}
        >
          {{@label}}
        </LinkTo>
      {{else if @route}}
        <LinkTo @route={{@route}} class={{if isActive "font-semibold" "underline"}}>
          {{@label}}
        </LinkTo>
      {{else}}
        <span class="font-semibold">{{@label}}</span>
      {{/if}}
    </li>
    <PhCaretRight @size="16" aria-hidden="true" class="last:hidden" />
  {{/let}}
</template>;

export interface TioPageBreadcrumbsSignature {
  Blocks: {
    default: [{ crumb: WithBoundArgs<typeof Crumb, 'model'> }];
  };
  Element: HTMLElement;
}

const TioPageBreadcrumbsComponent: TOC<TioPageBreadcrumbsSignature> = <template>
  <nav aria-label="Breadcrumbs" ...attributes>
    <ol class="tio-row-flush text-xs tio-fg-primary">
      {{yield (hash crumb=(component Crumb))}}
    </ol>
  </nav>
</template>;

export default TioPageBreadcrumbsComponent;
